import { render, staticRenderFns } from "./bqb.vue?vue&type=template&id=966625ca&scoped=true"
import script from "./bqb.vue?vue&type=script&lang=js"
export * from "./bqb.vue?vue&type=script&lang=js"
import style0 from "./bqb.vue?vue&type=style&index=0&id=966625ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966625ca",
  null
  
)

export default component.exports